// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyCarzoFiY0GtiBFky9ot9dFc4DHziVLgAA",
    authDomain: "spring-simplified-form-system.firebaseapp.com",
    projectId: "spring-simplified-form-system",
    storageBucket: "spring-simplified-form-system.appspot.com",
    messagingSenderId: "827869938057",
    appId: "1:827869938057:web:8946d8664b925898c02158",
    measurementId: "G-3NVZWLE21Z"
  };

  const firebaseConfigProd = {
    apiKey: "AIzaSyDl_QSWWJ3Xc3zrycMduFqXnshvGoUFeaQ",
    authDomain: "sp-simplified-form-system-prod.firebaseapp.com",
    projectId: "sp-simplified-form-system-prod",
    storageBucket: "sp-simplified-form-system-prod.appspot.com",
    messagingSenderId: "1014429694649",
    appId: "1:1014429694649:web:2f2c3f9e89cab252e9b968",
    measurementId: "G-CFHHCG86NH"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfigProd);
export const auth = getAuth(app);
export default app;